import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SecurityRoleListComponent } from './security-role-list/security-role-list.component';
import { SecurityRoleComponent } from './security-role/security-role.component';


import { AuthGuard } from '@core/utilities/auth.guard';
import { Permission } from '@core/literals/permission.literal';
import { RedeploymentAuthorize } from '../../core/utilities/redeployment-authorize.guard';
import { Organizations } from '../../shared/literals/shared.literal';

const routes: Routes = [
  {
    path: '',
    component: SecurityRoleListComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.ViewSecurityRoles, undefined))]
  },
  {
    path: 'SecurityRole/Detail/:id',
    component: SecurityRoleComponent,
    canActivate: [AuthGuard, (RedeploymentAuthorize(Permission.CreateUpdateSecurityRoles, undefined))]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class SecurityRolesRoutingModule {

}
